import React from "react";
import {
  MessageCircle,
  Send,
  Camera,
  Music,
  Video,
  Paperclip,
  Globe,
} from "lucide-react";

// Mock data for WhatsApp-style chat interface
export const mockConversations = [
  {
    id: 123,
    channel_id: 1,
    customer_id: "customer_123",
    customer_name: "John Doe",
    status: "active",
    assigned_to: null,
    escalation_reason: null,
    escalated_at: null,
    resolved_at: null,
    created_at: "2025-09-04T06:33:23.666Z",
    updated_at: "2025-09-04T07:33:23.666Z",
    channel_name: "WhatsApp Business",
    agent_name: "Customer Support Bot",
    last_message: "Halo, jam berapa toko buka?",
    last_message_at: "2025-09-04T07:33:23.666Z",
    last_message_media_type: "text",
    has_media_files: false,
    message_count: 8,
    model_provider: "groq",
    model_name: "llama-3.3-70b-versatile",
    unread_count: 2,
    customer_avatar: null,
    is_online: true,
    is_pinned: false,
  },
  {
    id: 124,
    channel_id: 2,
    customer_id: "customer_124",
    customer_name: "Sarah Wilson",
    status: "escalated",
    assigned_to: "Human Agent",
    escalation_reason: "Complex technical issue",
    escalated_at: "2025-09-04T06:15:23.666Z",
    resolved_at: null,
    created_at: "2025-09-04T05:00:23.666Z",
    updated_at: "2025-09-04T06:15:23.666Z",
    channel_name: "Telegram",
    agent_name: "Technical Support Bot",
    last_message: "I need help with my payment processing",
    last_message_at: "2025-09-04T06:15:23.666Z",
    last_message_media_type: "image",
    has_media_files: true,
    message_count: 15,
    model_provider: "openai",
    model_name: "gpt-4",
    unread_count: 0,
    customer_avatar: null,
    is_online: false,
    is_pinned: true,
  },
  {
    id: 125,
    channel_id: 1,
    customer_id: "customer_125",
    customer_name: "Muhammad Rahman",
    status: "assigned",
    assigned_to: "Alice Johnson",
    escalation_reason: "Customer request refund",
    escalated_at: "2025-09-04T04:30:23.666Z",
    resolved_at: null,
    created_at: "2025-09-04T03:45:23.666Z",
    updated_at: "2025-09-04T04:30:23.666Z",
    channel_name: "WhatsApp Business",
    agent_name: "Sales Support Bot",
    last_message: "Can I get a refund for my order?",
    last_message_at: "2025-09-04T04:30:23.666Z",
    last_message_media_type: "document",
    has_media_files: true,
    message_count: 12,
    model_provider: "groq",
    model_name: "llama-3.3-70b-versatile",
    unread_count: 5,
    customer_avatar: null,
    is_online: true,
    is_pinned: false,
  },
  {
    id: 126,
    channel_id: 3,
    customer_id: "customer_126",
    customer_name: "Emma Thompson",
    status: "resolved",
    assigned_to: "Bob Smith",
    escalation_reason: null,
    escalated_at: null,
    resolved_at: "2025-09-04T02:00:23.666Z",
    created_at: "2025-09-03T20:00:23.666Z",
    updated_at: "2025-09-04T02:00:23.666Z",
    channel_name: "Web Chat",
    agent_name: "General Support Bot",
    last_message: "Thank you for your help!",
    last_message_at: "2025-09-04T02:00:23.666Z",
    last_message_media_type: "text",
    has_media_files: false,
    message_count: 6,
    model_provider: "openai",
    model_name: "gpt-3.5-turbo",
    unread_count: 0,
    customer_avatar: null,
    is_online: false,
    is_pinned: false,
  },
  {
    id: 127,
    channel_id: 4,
    customer_id: "customer_127",
    customer_name: "Li Wei",
    status: "active",
    assigned_to: null,
    escalation_reason: null,
    escalated_at: null,
    resolved_at: null,
    created_at: "2025-09-04T07:00:23.666Z",
    updated_at: "2025-09-04T07:30:23.666Z",
    channel_name: "Instagram",
    agent_name: "Social Media Bot",
    last_message: "Do you have this product in blue?",
    last_message_at: "2025-09-04T07:30:23.666Z",
    last_message_media_type: "image",
    has_media_files: true,
    message_count: 3,
    model_provider: "groq",
    model_name: "llama-3.1-8b-instant",
    unread_count: 1,
    customer_avatar: null,
    is_online: true,
    is_pinned: false,
  },
  {
    id: 128,
    channel_id: 1,
    customer_id: "customer_128",
    customer_name: "Carlos Rodriguez",
    status: "active",
    assigned_to: null,
    escalation_reason: null,
    escalated_at: null,
    resolved_at: null,
    created_at: "2025-09-04T05:30:23.666Z",
    updated_at: "2025-09-04T07:25:23.666Z",
    channel_name: "WhatsApp Business",
    agent_name: "Customer Support Bot",
    last_message: "📱 Voice message",
    last_message_at: "2025-09-04T07:25:23.666Z",
    last_message_media_type: "audio",
    has_media_files: true,
    message_count: 9,
    model_provider: "openai",
    model_name: "gpt-4",
    unread_count: 3,
    customer_avatar: null,
    is_online: false,
    is_pinned: false,
  },
  {
    id: 129,
    channel_id: 2,
    customer_id: "customer_129",
    customer_name: "Priya Sharma",
    status: "escalated",
    assigned_to: "David Wilson",
    escalation_reason: "Billing dispute",
    escalated_at: "2025-09-04T01:45:23.666Z",
    resolved_at: null,
    created_at: "2025-09-03T18:30:23.666Z",
    updated_at: "2025-09-04T01:45:23.666Z",
    channel_name: "Telegram",
    agent_name: "Billing Support Bot",
    last_message: "I was charged twice for the same order",
    last_message_at: "2025-09-04T01:45:23.666Z",
    last_message_media_type: "document",
    has_media_files: true,
    message_count: 18,
    model_provider: "groq",
    model_name: "llama-3.3-70b-versatile",
    unread_count: 0,
    customer_avatar: null,
    is_online: false,
    is_pinned: true,
  },
  {
    id: 130,
    channel_id: 3,
    customer_id: "customer_130",
    customer_name: "Michael Johnson",
    status: "resolved",
    assigned_to: null,
    escalation_reason: null,
    escalated_at: null,
    resolved_at: "2025-09-03T22:30:23.666Z",
    created_at: "2025-09-03T19:00:23.666Z",
    updated_at: "2025-09-03T22:30:23.666Z",
    channel_name: "Web Chat",
    agent_name: "Technical Support Bot",
    last_message: "Perfect, everything is working now!",
    last_message_at: "2025-09-03T22:30:23.666Z",
    last_message_media_type: "text",
    has_media_files: false,
    message_count: 11,
    model_provider: "openai",
    model_name: "gpt-4",
    unread_count: 0,
    customer_avatar: null,
    is_online: false,
    is_pinned: false,
  },
  {
    id: 131,
    channel_id: 1,
    customer_id: "customer_131",
    customer_name: "Anna Kowalski",
    status: "assigned",
    assigned_to: "Sophie Chen",
    escalation_reason: "Language preference",
    escalated_at: "2025-09-04T03:00:23.666Z",
    resolved_at: null,
    created_at: "2025-09-04T02:15:23.666Z",
    updated_at: "2025-09-04T03:00:23.666Z",
    channel_name: "WhatsApp Business",
    agent_name: "Customer Support Bot",
    last_message: "Czy możesz pomóc mi po polsku?",
    last_message_at: "2025-09-04T03:00:23.666Z",
    last_message_media_type: "text",
    has_media_files: false,
    message_count: 4,
    model_provider: "groq",
    model_name: "llama-3.1-8b-instant",
    unread_count: 2,
    customer_avatar: null,
    is_online: true,
    is_pinned: false,
  },
  {
    id: 132,
    channel_id: 4,
    customer_id: "customer_132",
    customer_name: "Ahmed Al-Rashid",
    status: "active",
    assigned_to: null,
    escalation_reason: null,
    escalated_at: null,
    resolved_at: null,
    created_at: "2025-09-04T07:15:23.666Z",
    updated_at: "2025-09-04T07:20:23.666Z",
    channel_name: "Instagram",
    agent_name: "Social Media Bot",
    last_message: "🎥 Video",
    last_message_at: "2025-09-04T07:20:23.666Z",
    last_message_media_type: "video",
    has_media_files: true,
    message_count: 2,
    model_provider: "openai",
    model_name: "gpt-3.5-turbo",
    unread_count: 1,
    customer_avatar: null,
    is_online: true,
    is_pinned: false,
  },
];

export const mockMessages = [
  {
    id: 1,
    conversation_id: 123,
    sender: "customer",
    customer_name: "John Doe",
    content: "Halo, saya mau tanya jam berapa toko buka?",
    timestamp: "2025-09-04T07:30:23.666Z",
    type: "text",
    status: "read",
    media_url: null,
  },
  {
    id: 2,
    conversation_id: 123,
    sender: "agent",
    customer_name: null,
    content:
      "Selamat pagi! Toko kami buka setiap hari jam 08:00-22:00 WIB. Adakah yang bisa saya bantu hari ini?",
    timestamp: "2025-09-04T07:31:23.666Z",
    type: "text",
    status: "read",
    media_url: null,
  },
  {
    id: 3,
    conversation_id: 123,
    sender: "customer",
    customer_name: "John Doe",
    content: "Oke terima kasih. Apakah ada promo hari ini?",
    timestamp: "2025-09-04T07:32:23.666Z",
    type: "text",
    status: "read",
    media_url: null,
  },
  {
    id: 4,
    conversation_id: 123,
    sender: "agent",
    customer_name: null,
    content:
      "Ya, hari ini ada promo diskon 20% untuk semua produk elektronik! Promo berlaku sampai jam 18:00 hari ini.",
    timestamp: "2025-09-04T07:33:23.666Z",
    type: "text",
    status: "delivered",
    media_url: null,
  },
  {
    id: 5,
    conversation_id: 123,
    sender: "customer",
    customer_name: "John Doe",
    content: "Halo, jam berapa toko buka?",
    timestamp: "2025-09-04T07:33:23.666Z",
    type: "text",
    status: "sent",
    media_url: null,
  },
];

// Helper functions
export const getRelativeTime = (timestamp) => {
  const now = new Date();
  const messageTime = new Date(timestamp);
  const diffInMinutes = Math.floor((now - messageTime) / (1000 * 60));
  const diffInHours = Math.floor(diffInMinutes / 60);
  const diffInDays = Math.floor(diffInHours / 24);

  if (diffInMinutes < 1) return "now";
  if (diffInMinutes < 60) return `${diffInMinutes}m`;
  if (diffInHours < 24) return `${diffInHours}h`;
  if (diffInDays === 1) return "Yesterday";
  if (diffInDays < 7)
    return messageTime.toLocaleDateString("en-US", { weekday: "short" });
  return messageTime.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
  });
};

export const getStatusColor = (status) => {
  switch (status) {
    case "active":
      return "bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-400";
    case "escalated":
      return "bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-400";
    case "assigned":
      return "bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-400";
    case "resolved":
      return "bg-gray-100 text-gray-800 dark:bg-gray-900/30 dark:text-gray-400";
    default:
      return "bg-gray-100 text-gray-800 dark:bg-gray-900/30 dark:text-gray-400";
  }
};

export const getChannelIcon = (channelName) => {
  // Add null safety check
  if (!channelName || typeof channelName !== "string") {
    return <MessageCircle className="w-3 h-3 text-gray-500" />;
  }

  switch (channelName.toLowerCase()) {
    case "whatsapp business":
    case "whatsapp":
      return <MessageCircle className="w-3 h-3 text-green-600" />;
    case "telegram":
      return <Send className="w-3 h-3 text-blue-500" />;
    case "instagram":
      return <Camera className="w-3 h-3 text-pink-500" />;
    case "web chat":
      return <Globe className="w-3 h-3 text-blue-600" />;
    default:
      return <MessageCircle className="w-3 h-3 text-gray-500" />;
  }
};

export const getMediaIcon = (mediaType) => {
  // Add null safety check
  if (!mediaType || typeof mediaType !== "string") {
    return null;
  }

  switch (mediaType.toLowerCase()) {
    case "image":
      return <Camera className="w-3 h-3 text-gray-500" />;
    case "audio":
      return <Music className="w-3 h-3 text-gray-500" />;
    case "video":
      return <Video className="w-3 h-3 text-gray-500" />;
    case "document":
      return <Paperclip className="w-3 h-3 text-gray-500" />;
    default:
      return null;
  }
};
